import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import {useQuery} from "@apollo/react-hooks";
import gql from "graphql-tag";
import ActionButton from "../../components/ActionButton";
import {requestEditNote} from "../NotesActions";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import PanelGroupController from "../../components/PanelGroupController";
import Conditional from "../../components/Conditional";
import { fromJS } from "immutable";
import styles from "./NotesPanel.module.scss";
import NoteView from "./NoteView";

export default function NotesPanel(props) {
  const dispatch = useDispatch();
  let {foreignId, foreignType} = props;
  let {loading, error, data, subscribeToMore, refetch} = useQuery(GET_NOTES_FOR_FOREIGN_ID, {variables: {foreignType, foreignId}, fetchPolicy: "network-only"});
  let topic = `${foreignType}:${foreignId}`;

  useEffect(() => {
    let unsubscribeNewNote = subscribeToMore({
      document: ON_NEW_NOTE,
      variables: {topic: topic},
      updateQuery: (prev, {subscriptionData}) => {
        if (!subscriptionData.data) return prev;
        refetch();
        return prev;
      }
    });
    let unsubscribeToUpdates = subscribeToMore({
      document: ON_UPDATED_NOTE,
      variables: {noteId: "*"},
      updateQuery: (prev, {subscriptionData}) => {
        if (!subscriptionData.data) return prev;
        refetch();
        return prev;
      }
    });

    return () => {
      unsubscribeNewNote();
      unsubscribeToUpdates();
    }
  }, [topic, refetch]);

  function handleEditNote(noteId) {
    dispatch(requestEditNote(noteId));
  }

  if (loading) return <Loading />
  if (error) return <GraphQLErrors error={error} />

  let notes = fromJS(data.notesForForeignId);
  let elements = notes.map(x => <Note key={x.get("noteId")} data={x} onClick={handleEditNote} />);

  return (
    <div className={styles.module}>
      <Conditional show={notes.size === 0}>
        <p className={styles.empty}>No notes found.</p>
      </Conditional>
      {elements}
    </div>
  )
}

function Note({data, onClick}) {

  function handleClick(e) {
    e.preventDefault();
    onClick(data.get("noteId"));
  }

  return (
    <PanelGroupController title="Note" expanded={true}>
      <NoteView data={data} />
      <ActionButton label="Edit Note" onClick={handleClick} />
    </PanelGroupController>
  )
}

const ON_NEW_NOTE = gql`
  subscription($topic:String!) {
    newNote(topic: $topic) {
      id
      action
    }
  }
`

const ON_UPDATED_NOTE = gql`
  subscription updatedNote($noteId:ID!){
    updatedNote(noteId: $noteId) {
      id
      action
    }
  }
`

const GET_NOTES_FOR_FOREIGN_ID = gql`
  query notesForForeignId($foreignType:String!, $foreignId:ID!) {
    notesForForeignId(foreignType: $foreignType, foreignId: $foreignId) {
      noteId,
      foreignId,
      foreignType,
      status,
      title,
      descriptionHtml,
      tags,
      createdBy,
      createdByName,
      updatedBy,
      updatedByName,
      insertedAt,
      updatedAt,
    }
  }
`;